import { useTranslation } from 'react-i18next'

import { useDeleteWatchlist } from '@pages/Trade/Markets/Instruments/hooks/useDeleteWatchlist'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface DeleteWatchlistModalProps {
  watchlistId: number
  onDeleted?: () => void
}

export const DeleteWatchlistModal: BaseModalType<DeleteWatchlistModalProps> = ({
  close,
  watchlistId,
  onDeleted,
}) => {
  const { t } = useTranslation()
  const { mutate: deleteWatchlist, isPending } = useDeleteWatchlist()

  return (
    <Modal>
      <Modal.Header>{t('Instruments.Delete watchlist')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{t('Instruments.Delete watchlist confirmation')}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() =>
            deleteWatchlist(watchlistId, {
              onSuccess: () => {
                onDeleted?.()
                close()
              },
            })
          }
          disabled={isPending}
          loading={isPending}
        >
          {t('Delete')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
